import { Routes, Route, useParams, Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useAuth } from "../../components/useAuth";
import { useForm } from "react-hook-form";
import "./Announcement.css"; // ★ 共通デザイン

const ItemsRow = (props) => {
  return (
    <div className="ann-row ann-row-body">
      <div className="ann-col ann-col-staff-name">{props.name}</div>
      <div className="ann-col ann-col-staff-title" title={props.title}>
        {props.title}
      </div>
      <div className="ann-col ann-col-staff-sort">{props.sortno}</div>
      <div className="ann-col ann-col-actions">
        <Link
          to={"/staff/" + props.id}
          data-id={props.id}
          className="btn btn-ghost btn-sm"
          style={{ marginRight: "0.2rem" }}
        >
          編集
        </Link>
        <Link
          to={"/staff/delete/" + props.id}
          data-id={props.id}
          className="btn btn-danger btn-sm"
        >
          削除
        </Link>
      </div>
    </div>
  );
};

const api_url = "https://api.ope-note.jp/admin/staff.php";

const StaffHome = () => {
  const [itemList, setItemList] = useState([]);
  const [page, setCurrentPage] = useState(1);
  const { token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(api_url, {
          method: "POST",
          mode: "cors",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            page: page,
            mode: "list",
            token: token,
          }),
        });
        if (!response.ok) {
          if (response.status === 404 || response.status === 401) {
            navigate("/login");
          }
          throw new Error(response.status);
        }
        const data = await response.json();
        setItemList(data.data);
      } catch (err) {
        console.log(err);
        setItemList([]);
      }
    };
    fetchData();
  }, [page, token, navigate]);

  const tablelist = itemList.map((item) => (
    <ItemsRow
      key={item.id}
      title={item.title}
      id={item.id}
      name={item.name}
      sortno={item.sortno}
      filename={item.photo}
    />
  ));

  return (
    <>
      <div className="announcement-header">
        <h4 className="announcement-title">スタッフ一覧</h4>
        <Link to="0" className="btn btn-primary">
          ＋ 新規作成
        </Link>
      </div>

      <div className="announcement-card">
        <div className="ann-row ann-row-header">
          <div className="ann-col ann-col-staff-name">名前</div>
          <div className="ann-col ann-col-staff-title">役職</div>
          <div className="ann-col ann-col-staff-sort">表示順</div>
          <div className="ann-col ann-col-actions">操作</div>
        </div>
        {tablelist.length > 0 ? (
          <div className="ann-table-body">{tablelist}</div>
        ) : (
          <div className="ann-empty">登録されているスタッフはいません。</div>
        )}
      </div>
    </>
  );
};

const StaffForm = () => {
  const { id } = useParams();
  const { token } = useAuth();
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [photoUrl, setPhotoUrl] = useState("");
  const [file, setFile] = useState(null);
  const [fileStatus, setFileStatus] = useState("init");

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setFileStatus("init");
      setFile(e.target.files[0]);
      // プレビュー用 (ローカル選択時)
      const url = URL.createObjectURL(e.target.files[0]);
      setPhotoUrl(url);
    }
  };

  const fetchData = async (edit_id) => {
    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mode: "row", token: token, id: edit_id }),
      });
      if (!response.ok) {
        throw new Error(response.status);
      }
      const data = await response.json();
      if (data.result) {
        setValue("title", data.data.title);
        setValue("name", data.data.name);
        setValue("photo", data.data.photo);
        setValue("sortno", data.data.sortno);
        setPhotoUrl(data.data.photourl); // サーバー上のURL
      } else {
        navigate("/staff");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (id > 0) {
      fetchData(id);
    } else {
      setValue("sortno", 100);
    }
  }, [id, token, setValue]);

  const onSubmit = async (data) => {
    if (file || data.id) {
      const fd = new FormData();
      if (file) {
        fd.append("upfile", file);
      }
      fd.append("id", data.id);
      fd.append("title", data.title);
      fd.append("name", data.name);
      fd.append("sortno", data.sortno);
      fd.append("token", token);

      if (data.id) {
        fd.append("mode", "edit");
      } else {
        fd.append("mode", "add");
      }

      setFileStatus("uploading");
      try {
        const response = await fetch(api_url, {
          method: "POST",
          mode: "cors",
          credentials: "include",
          body: fd,
        });

        if (!response.ok) {
          throw new Error(response.status);
        }
        const resData = await response.json();
        setFileStatus("success");
        if (resData.result) {
          navigate("/staff");
        } else {
          setError(resData.error);
        }
        return true;
      } catch (err) {
        console.log(err);
        setFileStatus("failed");
        setError("通信エラーです");
      }
    } else {
      setError("写真ファイルを選択してください");
    }
  };

  return (
    <div className="announcement-form-wrapper">
      <div className="announcement-form-header">
        <Link to="../../staff" className="btn btn-ghost">
          ＜ 一覧へ戻る
        </Link>
        <h4 className="announcement-title">
          {id > 0 ? "スタッフ情報の編集" : "スタッフ情報の新規登録"}
        </h4>
      </div>

      <form className="frm ann-form-card" onSubmit={handleSubmit(onSubmit)}>
        {error && <div className="frm-error">{error}</div>}

        <div className="frm-row">
          <label>名前</label>
          <input
            type="text"
            className="frm-input"
            {...register("name", {
              required: true,
            })}
          />
          {errors.name && (
            <div className="frm-error-text">入力が必須の項目です</div>
          )}
        </div>

        <div className="frm-row">
          <label>役職</label>
          <input
            type="text"
            className="frm-input"
            {...register("title", {
              required: true,
            })}
          />
          {errors.title && (
            <div className="frm-error-text">入力が必須の項目です</div>
          )}
        </div>

        <div className="frm-row">
          <label>写真</label>
          <input type="file" name="upfile" onChange={handleFileChange} />
          {fileStatus === "uploading" && (
            <div className="frm-info-text">アップロード中...</div>
          )}
          {photoUrl && (
            <img
              src={photoUrl}
              alt="staff"
              className="staff-photo-preview"
            />
          )}
        </div>

        <div className="frm-row">
          <label>並び順</label>
          <input
            type="number"
            className="frm-input"
            {...register("sortno", {
              required: true,
            })}
          />
          {errors.sortno && (
            <div className="frm-error-text">入力が必須の項目です</div>
          )}
        </div>

        <input type="hidden" name="id" {...register("id")} defaultValue={id} />

        <div className="frm-footer">
          <button type="submit" className="btn btn-primary">
            更新する
          </button>
        </div>
      </form>
    </div>
  );
};

const StaffDeleteConfirm = () => {
  const { id } = useParams();
  const { token } = useAuth();
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [viewData, setViewData] = useState([]);

  const { register, handleSubmit } = useForm();

  const fetchData = async (edit_id) => {
    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mode: "detail", token: token, id: edit_id }),
      });
      if (!response.ok) {
        throw new Error(response.status);
      }
      const data = await response.json();
      if (data.result) {
        setViewData(data.data);
      } else {
        navigate("/staff");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (id > 0) {
      fetchData(id);
    } else {
      navigate("/staff");
    }
  }, [id]);

  const onSubmit = async (data) => {
    const post_data = {
      id: data.id,
      token: token,
      mode: "delete",
    };
    try {
      const response = await fetch(api_url, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(post_data),
      });

      if (!response.ok) {
        throw new Error(response.status);
      }
      const resData = await response.json();

      if (resData.result) {
        navigate("/staff");
      } else {
        setError(resData.error);
      }
      return true;
    } catch (err) {
      console.log(err);
      setError("通信エラーです");
    }
  };

  return (
    <div className="announcement-form-wrapper">
      <div className="announcement-form-header">
        <Link to="../../staff" className="btn btn-ghost">
          ＜ 一覧へ戻る
        </Link>
        <h4 className="announcement-title">スタッフ削除確認</h4>
      </div>

      <form className="frm ann-form-card" onSubmit={handleSubmit(onSubmit)}>
        {error && <div className="frm-error">{error}</div>}

        <div className="frm-row">
          <div className="delete-warning">
            このスタッフ情報を削除しますか？（元に戻せません）
          </div>
        </div>

        <div className="frm-row">
          <label>名前</label>
          <div className="frm-static">{viewData.name}</div>
        </div>
        <div className="frm-row">
          <label>役職</label>
          <div className="frm-static">{viewData.title}</div>
        </div>
        <div className="frm-row">
          <label>写真</label>
          <div className="frm-static">
            {viewData.photourl ? (
              <img
                src={viewData.photourl}
                alt="staff"
                className="staff-photo-preview"
              />
            ) : (
              viewData.photo
            )}
          </div>
        </div>
        <div className="frm-row">
          <label>並び順</label>
          <div className="frm-static">{viewData.sortno}</div>
        </div>

        <input type="hidden" name="id" {...register("id")} defaultValue={id} />

        <div className="frm-footer frm-footer-between">
          <button
            type="button"
            className="btn btn-ghost"
            onClick={() => navigate("/staff")}
          >
            キャンセル
          </button>
          <button type="submit" className="btn btn-danger">
            削除する
          </button>
        </div>
      </form>
    </div>
  );
};

const Staff = () => {
  return (
    <div className="announcement-page">
      <div className="sub_title">スタッフ</div>
      <div className="announcement-inner">
        <Routes>
          <Route path="/" element={<StaffHome />} />
          <Route path=":id" element={<StaffForm />} />
          <Route path="/delete/:id" element={<StaffDeleteConfirm />} />
        </Routes>
      </div>
    </div>
  );
};

export default Staff;
